export default __webpack_public_path__ + "static/media/fluentd.ee4c08f8.svg";